var map = {
	"./Amazon_logo.png": 944,
	"./Amazon_logo.svg": 945,
	"./Disagg101/Disagg101-1.png": 946,
	"./Disagg101/air-conditioner.png": 947,
	"./Disagg101/bulb.png": 948,
	"./Disagg101/chargeable-car.png": 949,
	"./Disagg101/electricity.png": 950,
	"./Disagg101/fridge.png": 951,
	"./Disagg101/heater.png": 952,
	"./Disagg101/laundry.png": 953,
	"./Disagg101/movie.png": 954,
	"./Disagg101/oven-on.png": 955,
	"./Disagg101/pool.png": 956,
	"./Disagg101/power.png": 957,
	"./Disagg101/selected-check.png": 958,
	"./Disagg101/thumbs-down.png": 959,
	"./Disagg101/thumbs-up.png": 960,
	"./Disagg101/video.png": 961,
	"./Disagg101/water-heater.png": 962,
	"./HomeDepot_logo.svg": 963,
	"./Vector.png": 964,
	"./Wayfair_logo.svg": 965,
	"./amazon-logo.png": 966,
	"./arrow-down.png": 967,
	"./arrow-up.png": 968,
	"./bidgely.png": 969,
	"./bluePattern.svg": 970,
	"./bulb.png": 971,
	"./clone.png": 972,
	"./electric.svg": 973,
	"./emailPreview.png": 974,
	"./footerIcons/IN-white.png": 315,
	"./footerIcons/YT-white.png": 316,
	"./footerIcons/fb-white.png": 317,
	"./footerIcons/ig-white.png": 318,
	"./footerIcons/tw-white.png": 319,
	"./gas.svg": 975,
	"./grass.svg": 976,
	"./herbie_fair.png": 977,
	"./herbie_good.png": 978,
	"./herbie_great.png": 979,
	"./icn-bidgely-loader.gif": 980,
	"./icon-always-on.svg": 981,
	"./icon-cooking.svg": 982,
	"./icon-entertainment.svg": 983,
	"./icon-laundry.svg": 984,
	"./icon-lighting.svg": 985,
	"./icon-other.svg": 986,
	"./icon-pool-pump.svg": 987,
	"./icon-refrigeration.svg": 988,
	"./icon-whole-home.svg": 989,
	"./leaves-left.svg": 990,
	"./leaves-right.svg": 991,
	"./loading.gif": 992,
	"./loading.svg": 993,
	"./loadingMce.svg": 994,
	"./logo.svg": 995,
	"./orangePattern.svg": 996,
	"./placeholderFrame.png": 997,
	"./preferences.svg": 998,
	"./redPattern.svg": 999,
	"./stars.png": 1000,
	"./thermostat.jpg": 1001,
	"./views.png": 1002
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 943;